import {Component, OnDestroy, OnInit} from '@angular/core';
import {
    CanvasService,
    ControlService,
    MenuService, ParametersService,
    ScheduleIntervalsService
} from "../../core";
import {Subscription} from "rxjs";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'controls',
    templateUrl: './controls.component.html',
    styleUrls: ['./controls.component.scss']
})
export class ControlsComponent implements OnInit, OnDestroy {
    private elementSubscription: Subscription;
    private elementValSubscription: Subscription;
    template: string = '';

    constructor(
        public control: ControlService,
        private canvas: CanvasService,
        private menu: MenuService,
        private parameters: ParametersService,
        public scheduleIntervals: ScheduleIntervalsService,
        private $state: StateService,
    ) {
    }

    ngOnInit() {
        this.control.comeFromControl = true;
        this.template = this.setControlTemplate(this.control.template);

        this.elementValSubscription = this.control.elementVal$.subscribe((newVal) => {
            if (newVal !== undefined && newVal.type === 29) this.canvas.loadCanvasJS();
        });
        this.elementSubscription = this.control.element$.subscribe((newVal) => {
            this.menu.updateElementMenu(newVal);
        });
    }

    ngOnDestroy() {
        this.elementSubscription.unsubscribe();
        this.elementValSubscription.unsubscribe();
    }

    private setControlTemplate(type: string | number): string {
        switch (type) {
            case 1:
            case 2:
            case 106:
                return 'one-switch';
            case 3:
            case 4:
            case 5:
                return 'two-switch';
            case 6:
                return 'input';
            case 7:
                return 'time-mode';
            case 10:
                return 'yes-no';
            case 20:
                return 'on-off';
            case 11:
            case 111:
                return 'checkbox';
            case 12:
                return 'schedule-plus-minus';
            case 13:
                return 'schedule-on-off';
            case 15:
                return 'select-box';
            case 29:
                return 'heating-curve-chart';
            case 28:
            case 30:
                return 'heating-curve';
            case 31:
                return 'heating-curve-shift';
            case 32:
                return 'group-code';
            case 45:
                return 'data-table';
            case 46:
                return 'data-table-different';
            case 50:
                return 'manufacturer-data';
            case 100:
                return 'schedule-multi';
            case 107:
                return 'date-picker-control';
            case 108:
                return 'date-interval';
            case 109:
                return 'date-format-control';
            case 112:
                return 'checkbox-expanded';
            case 120:
                return 'schedule-intervals';
            default:
                const element = this.control.element.getValue();
                if (element) {
                    this.menu.goToMenuByType(element.menuType);
                } else {
                    this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
                }
                return '';
        }
    }
}
